import "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@v3.0.0-rc.17/dist/cookieconsent.umd.js";

CookieConsent.run({
  guiOptions: {
    consentModal: {
      layout: "box",
      position: "middle center",
      equalWeightButtons: true,
      flipButtons: false,
    },
    preferencesModal: {
      layout: "box",
      position: "right",
      equalWeightButtons: true,
      flipButtons: false,
    },
  },
  categories: {
    necessary: {
      readOnly: true,
    },
    functionality: {},
    analytics: {},
    marketing: {},
  },
  language: {
    default: "de",
    autoDetect: "document",
    translations: {
      en: {
        consentModal: {
          title:
            "<span>Cookie Dashboard</span><svg style='float: right;' width=\"45\" height=\"26\" viewBox=\"0 0 45 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M43.9242 13.9371C42.6477 12.6606 40.5805 12.6606 39.3041 13.9371L38.9838 14.2573C37.9644 15.0546 36.3503 15.9912 35.3025 14.9979C35.0498 14.7583 34.991 14.3226 34.9867 14.0003C34.9671 12.6759 35.8602 10.2405 38.3347 7.3913L39.0514 6.67465C39.1995 6.52652 39.3302 6.36533 39.4435 6.1976C39.4544 6.18453 39.4674 6.17364 39.4783 6.16057L39.5175 6.12136C39.7114 5.92749 39.8116 5.67699 39.829 5.42212C40.2189 4.27852 39.9619 2.965 39.0514 2.0523C37.7749 0.775815 35.7055 0.775815 34.4312 2.0523L29.2752 7.20833C29.2164 7.24754 29.1597 7.29546 29.1075 7.34774L28.674 7.78993C27.4149 8.99671 26.0774 9.58485 24.9404 9.41494C24.337 9.32563 23.9405 9.02938 23.8251 8.79413C23.4199 7.95331 23.7009 7.27368 24.2346 6.14096C24.814 4.9124 25.5808 3.28521 24.3413 1.48812C24.2629 1.36613 24.1714 1.25068 24.0756 1.13741C23.9623 1.00236 23.8403 0.865125 23.7031 0.727893C23.5833 0.608086 23.4439 0.527489 23.2958 0.47521C22.0389 -0.289372 20.3769 -0.132535 19.2921 0.954436L0.95736 19.2935C-0.31912 20.57 -0.31912 22.6394 0.95736 23.9137C1.5956 24.5519 2.43207 24.87 3.26853 24.87C4.105 24.87 4.94146 24.5519 5.5797 23.9137L16.9787 12.5147C17.0157 12.4863 17.055 12.4624 17.0876 12.4297C18.07 11.4952 19.1635 10.9877 20.0959 11.0421C20.6078 11.0704 21.0347 11.2709 21.3309 11.6237C22.2262 12.6867 22.2676 13.7824 20.0937 16.3964L16.0987 20.3914C14.8222 21.6679 14.8222 23.7373 16.0987 25.0116C16.7369 25.6498 17.5734 25.9678 18.4099 25.9678C19.2463 25.9678 20.0828 25.6498 20.721 25.0116L30.2315 15.5011C31.1093 14.8607 31.8216 14.6625 32.2486 14.8149C32.73 14.987 33.0284 15.7342 33.0262 16.7667C33.0262 17.5051 32.7714 18.4592 32.523 19.385C32.3052 20.2041 32.0656 21.0993 31.9828 21.9685C31.7388 23.0293 32.0286 24.186 32.8541 25.0116C33.4924 25.6498 34.3288 25.9678 35.1653 25.9678C36.0018 25.9678 36.8382 25.6498 37.4765 25.0116L43.9264 18.5616C45.2029 17.2851 45.2029 15.2179 43.9264 13.9414L43.9242 13.9371Z\" fill=\"#43334B\"/> </svg>",
          description:
            'By clicking "agree", you agree that we may track your use of our platform through cookies (from Medicross and third parties) to analyze and personalize your user experience and advertisements displayed to you.\n\t\t<div id="cc-custom-list-type"><p>Essential</p><p>Statistics</p><p>Marketing</p></div>\n\t\t',
          acceptAllBtn: "Accept all",
          showPreferencesBtn: "Change Settings",
        },
        preferencesModal: {
          title: "Consent Preferences Center",
          acceptAllBtn: "Accept all",
          savePreferencesBtn: "Save preferences",
          closeIconLabel: "Close modal",
          serviceCounterLabel: "Service|Services",
          sections: [
            {
              title: "Cookie Usage",
              description:
                'By clicking "agree", you agree that we may track your use of our platform through cookies (from Medicross and third parties) to analyze and personalize your user experience and advertisements displayed to you.',
            },
            {
              title: 'Essential',
              description:
                "Medicross needs these cookies to function as a website. That's why they can't be turned off - without basic cookies, nothing works here. They ensure that you are safe and comfortable on Medicross.",
              linkedCategory: "necessary",
            },
            {
              title: "Statistics",
              description:
                "Statistics cookies help website owners understand how visitors interact with websites by collecting and reporting information anonymously.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                "These cookies give us important information about the behavior of our visitors. They collect information about what interests users the most on Medicross or which pages are used most frequently. This allows us to tailor Medicross to the needs of our customers. We also collect this data anonymously. We only want to show you ads that are of interest to you. That's why we use cookies that record your search criteria and ensure that you see bowls that are relevant to you on <a href='https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0'>Facebook</a> or <a href='https://business.safety.google/intl/de/privacy/</a>",
              linkedCategory: "marketing",
            },
            {
              title: "More information",
              description:
                'For any queries in relation to our policy on cookies and your choices, please <a class="cc__link" href="#https://www.medicross.com/pages/kontakt">contact us</a>.',
            },
          ],
        },
      },
      de: {
        consentModal: {
          title:
            "<span>Cookie Dashboard</span> <svg style='float: right;' width=\"45\" height=\"26\" viewBox=\"0 0 45 26\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M43.9242 13.9371C42.6477 12.6606 40.5805 12.6606 39.3041 13.9371L38.9838 14.2573C37.9644 15.0546 36.3503 15.9912 35.3025 14.9979C35.0498 14.7583 34.991 14.3226 34.9867 14.0003C34.9671 12.6759 35.8602 10.2405 38.3347 7.3913L39.0514 6.67465C39.1995 6.52652 39.3302 6.36533 39.4435 6.1976C39.4544 6.18453 39.4674 6.17364 39.4783 6.16057L39.5175 6.12136C39.7114 5.92749 39.8116 5.67699 39.829 5.42212C40.2189 4.27852 39.9619 2.965 39.0514 2.0523C37.7749 0.775815 35.7055 0.775815 34.4312 2.0523L29.2752 7.20833C29.2164 7.24754 29.1597 7.29546 29.1075 7.34774L28.674 7.78993C27.4149 8.99671 26.0774 9.58485 24.9404 9.41494C24.337 9.32563 23.9405 9.02938 23.8251 8.79413C23.4199 7.95331 23.7009 7.27368 24.2346 6.14096C24.814 4.9124 25.5808 3.28521 24.3413 1.48812C24.2629 1.36613 24.1714 1.25068 24.0756 1.13741C23.9623 1.00236 23.8403 0.865125 23.7031 0.727893C23.5833 0.608086 23.4439 0.527489 23.2958 0.47521C22.0389 -0.289372 20.3769 -0.132535 19.2921 0.954436L0.95736 19.2935C-0.31912 20.57 -0.31912 22.6394 0.95736 23.9137C1.5956 24.5519 2.43207 24.87 3.26853 24.87C4.105 24.87 4.94146 24.5519 5.5797 23.9137L16.9787 12.5147C17.0157 12.4863 17.055 12.4624 17.0876 12.4297C18.07 11.4952 19.1635 10.9877 20.0959 11.0421C20.6078 11.0704 21.0347 11.2709 21.3309 11.6237C22.2262 12.6867 22.2676 13.7824 20.0937 16.3964L16.0987 20.3914C14.8222 21.6679 14.8222 23.7373 16.0987 25.0116C16.7369 25.6498 17.5734 25.9678 18.4099 25.9678C19.2463 25.9678 20.0828 25.6498 20.721 25.0116L30.2315 15.5011C31.1093 14.8607 31.8216 14.6625 32.2486 14.8149C32.73 14.987 33.0284 15.7342 33.0262 16.7667C33.0262 17.5051 32.7714 18.4592 32.523 19.385C32.3052 20.2041 32.0656 21.0993 31.9828 21.9685C31.7388 23.0293 32.0286 24.186 32.8541 25.0116C33.4924 25.6498 34.3288 25.9678 35.1653 25.9678C36.0018 25.9678 36.8382 25.6498 37.4765 25.0116L43.9264 18.5616C45.2029 17.2851 45.2029 15.2179 43.9264 13.9414L43.9242 13.9371Z\" fill=\"#43334B\"/> </svg>",
          description:
            'Mit Klick auf "Einverstanden" stimmst Du zu, dass wir Deine Nutzung unserer Plattform durch Cookies (von Medicross und Dritten) nachverfolgen, um Deine Nutzungserfahrung und Dir angezeigte Werbung zu analysieren und personalisieren.',
          acceptAllBtn: "Einverstanden",
          showPreferencesBtn: "Einstellungen anpassen",
          footer: "Mehr Erfahren: <a href=\'https://business.safety.google/intl/de/privacy/'> Google Datenschutzerklärung & Nutzungsbedingungen</a>"
        },
        preferencesModal: {
          title: "Präferenzen für die Zustimmung",
          acceptAllBtn: "Alle akzeptieren",
          savePreferencesBtn: "Speichern & schließen",
          closeIconLabel: "Modal schließen",
          serviceCounterLabel: "Dienstleistungen",
          sections: [
            {
              title: "Verwendung von Cookies",
              description:
                'Mit Klick auf "Alle akzeptieren" stimmst Du zu, dass wir Deine Nutzung unserer Plattform durch Cookies (von Medicross und Dritten) nachverfolgen, um Deine Nutzungserfahrung und Dir angezeigte Werbung zu analysieren und personalisieren.',
            },
            {
              title: 'Essential',
              description:
                "Diese Cookies braucht Medicross, um als Website zu funktionieren. Deshalb können sie auch nicht abgeschaltet werden – ohne Basiscookies geht hier schlichtweg nichts. Sie sorgen dafür, dass Du auf Medicross sicher und bequem unterwegs bist.",
              linkedCategory: "necessary",
            },
            {
              title: "Statistik",
              description:
                "Statistik-Cookies helfen Webseiten-Besitzern zu verstehen, wie Besucher mit Webseiten interagieren, indem Informationen anonym gesammelt und gemeldet werden.",
              linkedCategory: "analytics",
            },
            {
              title: "Marketing",
              description:
                'Diese Cookies geben uns wichtige Hinweise zum Verhalten unserer Besucher. Sie sammeln Informationen darüber, was User auf Medicross am meisten interessiert oder welche Seiten am häufigsten genutzt werden. So können wir Medicross auf die Bedürfnisse unserer Kunden ausrichten. Auch diese Daten erheben wir anonym. Wir wollen Dir nur Anzeigen präsentieren, die Dich auch interessieren. Deshalb verwenden wir Cookies, die Deine Suchkriterien erfassen und dafür sorgen, dass Du auf <a class="cc-link" href="https://www.facebook.com/privacy/policy/?entry_point=data_policy_redirect&entry=0">Facebook</a> oder <a class="cc-link" href="https://policies.google.com/privacy?hl=de">Google</a>  Produkte siehst, die zu Dir passen.',
              linkedCategory: "marketing",
            },
            {
              title: "Mehr Informationen",
              description:
                'Bei Fragen zu unserer Richtlinie, zu Cookies und Deinen Auswahlmöglichkeiten <a class="cc-link" href="https://www.medicross.com/pages/kontakt">kontaktiere uns</a> gerne oder informieren Dich über unsere <a class="cc-link" href="https://www.medicross.com/policies/privacy-policy">Datenschutzrichtlinien</a>.',
            },
          ],
        },
      },
    },
  },
  disablePageInteraction: true,
  onConsent: ({cookie}) => {
    let gtagConsentConfig = {};
    if (cookie.categories.includes('necessary') && cookie.categories.includes('functionality') && cookie.categories.includes('analytics') && cookie.categories.includes('marketing')) {
        gtagConsentConfig = {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        };
    } else if (cookie.categories.length === 1 && cookie.categories.includes('necessary')) {
        gtagConsentConfig = {
            'functionality_storage': 'granted'
        };
    } else if (cookie.categories.includes('necessary') && categories.includes('analytics') && cookie.categories.length === 2) {
        gtagConsentConfig = {
            'functionality_storage': 'granted',
            'analytics_storage': 'granted'
        };
    }
    else if (cookie.categories.includes('necessary') && categories.includes('marketing') && cookie.categories.length === 2) {
        gtagConsentConfig = {
            'functionality_storage': 'granted',
            'ad_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        };
    }
    else if (cookie.categories.length === 3) {
gtagConsentConfig = {
            'ad_storage': 'granted',
            'analytics_storage': 'granted',
            'functionality_storage': 'granted',
            'ad_personalization': 'granted',
            'ad_user_data': 'granted'
        };
    }

    //gtag('consent', 'update', gtagConsentConfig);
    }
});